import Paper from '@mui/material/Paper'

import StyledTable from '@components/StyledTable'

import { Page } from '../../theme/components/Page'
import { PageSection } from '../../theme/components/PageSection'
import { useProjectmeldingValuelists } from '../../valuelists/hooks/useProjectmeldingValuelists'
import { useValuelists } from '../../valuelists/hooks/useValuelists'
import { ProjectmeldingenFilters } from '../components/ProjectmeldingenFilters'
import { ProjectmeldingenTableRow } from '../components/ProjectmeldingenTableRow'
import { useProjectmeldingenSearch } from '../hooks/useProjectmeldingenSearch'

const headerCells = [
  { id: 'projectName', numeric: false, label: 'Projectnaam', sort: true },
  { id: 'status', numeric: false, label: 'Status' },
  { id: 'companyName', numeric: false, label: 'Bedrijf', sort: true },

  {
    id: 'numberOfObjects',
    numeric: false,
    label: 'Aantal objecten',
    sort: true,
  },
  { id: 'tags', numeric: false, label: 'Planvorming onderwerpen', sort: false },
  { id: 'created', numeric: false, label: 'Datum aangeboden', sort: true },
  { id: 'projectCity', numeric: false, label: 'Projectplaats', sort: true },
  { id: 'details', numeric: false, label: 'Details', fixed: 75 },
]

export const Projectmeldingen = () => {
  const { data: valuelists } = useValuelists()
  const { data: projectmeldingValuelists } = useProjectmeldingValuelists()
  const {
    data: { items: projectmeldingen, count, skip, limit },
    isLoading,
    isError,
    initialFilters,
    onChangeFilters,
    onChangePage,
    filters,
    onReset,
    onRefresh,
    onChangeSort,
    sort,
  } = useProjectmeldingenSearch()

  return (
    <Page
      title={['Vooraanmeldingen', 'Ketensamenwerking']}
      breadcrumbs={[
        { label: 'Ketensamenwerking', href: '/home', tooltip: 'CAPO home' },
        { label: 'Vooraanmeldingen' },
      ]}
      fillScreen
    >
      <PageSection
        id="vooraanmeldingen"
        heading="Overzicht van uw vooraanmeldingen"
      />

      <Paper>
        <ProjectmeldingenFilters
          onChange={onChangeFilters}
          filters={filters}
          initialFilters={initialFilters}
          onReset={onReset}
          onRefresh={onRefresh}
          filterOptions={{
            ...valuelists,
            projectmelding: projectmeldingValuelists,
          }}
        />
        <StyledTable
          headerCells={headerCells}
          onChangePage={onChangePage}
          onChangeSort={onChangeSort}
          stats={{ count, skip, limit }}
          loading={isLoading}
          isError={isError}
          sort={sort}
        >
          {projectmeldingen.map((projectmelding) => (
            <ProjectmeldingenTableRow
              key={projectmelding.id}
              projectmelding={projectmelding}
            />
          ))}
        </StyledTable>
      </Paper>
    </Page>
  )
}
